module.exports = __webpack_public_path__ + "img/freesize-img.d3c676ac.png";